<template>
  <div class="intro_area">

    <div class="row">

      <div class="col-md-8 col-lg-6">
        <div class="box">
          <h5 class="title">التنبيهات</h5>
          <div class="box_inner notifications">
            <img src="@/assets/images/notify.png" alt="">
            <div class="text">
              <h2 class="box_title">مبروك</h2>
              <p>لقد وصلت لعبة البالوت 3250 مستخدم في أخر شهر</p>
              <button class="btn but_green">مشاهدة التفاصيل</button>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="clearfix">
            <h5 class="title float-right">نتيجة الإختبار</h5>
            <div class="get_a float-left">
              <select name="">
                <option value selected>أخر شهر</option>
              </select>
            </div>
          </div>
          <div class="box_inner">
            <table class="table table-responsive">

              <thead class="">
                <tr>
                  <th>إسم العائلة</th>
                  <th>عدد النقاط</th>
                  <th>نوع الإرتباط</th>
                </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, index) in 4" :key="index">
                    <td scope="row">عائلة راشد</td>
                    <td>103</td>
                    <td>وثيق</td>
                  </tr>
                </tbody>

            </table>
          </div>
        </div>

        <div class="box">
          <div class="box_inner chart_area resultTest p-4 clearfix">
            <span class="p-2 text-center">العمر</span>
            <Age :getseries="[2, 8]"></Age>
          </div>
        </div>

      </div>

      <div class="col-md-8 col-lg-6">

        <div class="box mb-5">
          <div class="clearfix">
            <h5 class="title float-right">الإحصائيات</h5>
            <div class="get_a float-left">
              <select name="">
                <option value selected>أخر شهر</option>
              </select>
            </div>
          </div>
          <div class="box_inner chart_area resultTest">
            <div class="row">
              <div class="col-md-6 col-lg-8">
                <div class="p-4">
                  <UsersNumber :getseries="[10, 41, 35, 51, 49, 62, 69, 91, 148]"></UsersNumber>
                </div>
              </div>
              <div class="col-md-6 col-lg-4">
                <div class="p-4 py-5 text_are text-center">
                  <p class="pt-4">عدد المستخدمين</p>
                  <h1><strong>21400</strong></h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="box">
              <div class="clearfix">
                <h5 class="title float-right">إحصائيات الأفراد</h5>
              </div>
              <div class="box_inner chart_area resultTest p-4 clearfix">
                <span class="p-2 text-center">الجنس</span>
                <Gender :getseries="[2, 8]"></Gender>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
  import UsersNumber from '@/views/dashboard/charts/UsersNumber.vue'
  import Gender from '@/views/dashboard/charts/Gender.vue'
  import Age from '@/views/dashboard/charts/Age.vue'
  export default {
    name: 'intro',
    components: {UsersNumber, Gender, Age},
  }
</script>
